import styled from 'styled-components';

export const StyledRef = styled.span`
    background-color: var(--gray-2);
    font-size: 12px;
    line-height: 20px;
    font-weight: 400;
    border-radius: 6px;
    padding: 1px 12px;
    margin-right: 4px;
`;
